var numberInput = {
    base: {
        display: "grid",
        gridTemplateColumns: "min-content 1fr min-content",
        gap: "0.5rem",
        alignItems: "center",
        justifyItems: "start",
        /* Chrome, Safari, Edge, Opera */
        "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
        },
        /* Firefox */
        "input[type=number]": {
            MozAppearance: "textfield",
        },
        input: {
            textAlign: "center",
        },
    },
    variants: {
        size: {
            sm: {
                width: "142px", // 62px input width
            },
            md: {
                width: "182px", // 78px input width
            },
            lg: {
                width: "214px", // 86px input width
            },
        },
    },
};

export { numberInput };
//# sourceMappingURL=number-input.js.map
